import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Brain } from '@phosphor-icons/react';

export default function AuthCallback() {
  const { googleLogin } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (match && match[1]) {
      const sessionId = match[1];
      googleLogin(sessionId)
        .then(() => navigate('/dashboard'))
        .catch(() => navigate('/login'));
    } else {
      navigate('/login');
    }
  }, [googleLogin, navigate]);

  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center text-primary font-heading text-2xl tracking-widest animate-pulse space-y-4">
        <Brain size={64} weight="duotone" />
        <p>AUTHENTICATING VIA SECURE CHANNEL...</p>
    </div>
  );
}